var React = require('react');

function OpenSauceIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.909 21.285A10.5 10.5 0 0 0 22.5 12c0-5.799-4.701-10.5-10.5-10.5S1.5 6.201 1.5 12a10.5 10.5 0 0 0 5.591 9.285l2.07-5.794a4.5 4.5 0 1 1 5.679 0l2.069 5.794Zm.509 1.425A12 12 0 0 0 24 12c0-6.627-5.373-12-12-12S0 5.373 0 12a12 12 0 0 0 7.963 11.304l3.028-8.478A3.001 3.001 0 0 1 12 9a3 3 0 0 1 1.01 5.826l3.027 8.478c.475-.17.936-.368 1.38-.594Z","fill":"#6D7584"}));
}

OpenSauceIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = OpenSauceIcon;

OpenSauceIcon.default = OpenSauceIcon;
